import React from "react";

export const About = () => {
  return (
    <div className="text-white w-3/4 md:w-1/2">

        <h3 className="text-2xl font-semibold my-8 text-yellow-400">About Us</h3>
      <p className="w-full">
        TheBookWorm is the ultimate destination for book lovers who are looking
        for a vast library of EPUB files. With a simple and user-friendly interface, you can easily search
        for and download your favorite books. TheBookWorm allows you to create
        customizable bookshelves to organize your collection and keep track of
        your reading progress. Start your
        reading journey today with TheBookWorm and discover a whole new world of
        books at your fingertips.
      </p>
    </div>
  );
};
